import { endOfDay, startOfDay } from "date-fns";

import api from "../services/api";
import { formatISODate } from "./date";

export const getPacksCount = url =>
  api
    .get(url)
    .then(count => ({ packsCount: count }))
    .catch(error => ({ error }));

export const createPacksCountUrl = (start, end) => {
  const startDate = formatISODate(startOfDay(start));
  const endDate = formatISODate(endOfDay(end));

  return `/v1/laundry/packs_count?start_date=${startDate}&end_date=${endDate}`;
};
